import { IoMenuSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { Avatar } from '../../../components/avatar/avatar';
import { Button } from '../../../components/button/button';
import { Divider } from '../../../components/divider/divider';
import { IconButton } from '../../../components/icon-button/icon-button';
import { Loader } from '../../../components/loader/loader';
import { DesktopNotifications } from '../../../features/notifications/desktop-notifications/desktop-notifications';
import { usePWAInstall } from '../../../features/notifications/use-pwa-install';
import { Tooltip } from '../../../features/tooltip/tooltip';
import { concatPath } from '../../../helpers/path';
import { CabinetPath, ManagerPath, RootPath } from '../../../routes/manager/manager-enums';
import { UserRole } from '../../../store/api/manager-api';
import { RolePermission } from '../../../store/api/role-api';
import { PermissionServiceType, useManagerStore } from '../../../store/use-manager-store';
import { adminRecord } from '../body/cabinet/company-settings/company-admins/helpers';
import { HeaderLang } from './header-lang/header-lang';
import s from './header.module.css';
import { useHeader } from './use-header';

const links: {
  title: string;
  path: string;
  roles?: UserRole[];
  service?: PermissionServiceType;
  permissions?: RolePermission[];
}[] = [
  {
    title: 'Настройки компании',
    path: concatPath([RootPath.Manager, ManagerPath.Cabinet, CabinetPath.CompanySettings]),
  },
  {
    title: 'Роли и доступы',
    path: concatPath([RootPath.Manager, ManagerPath.Cabinet, CabinetPath.RolesAndAccess]),
    roles: ['admin_head'],
  },
  {
    title: 'Приложение',
    path: concatPath([RootPath.Manager, ManagerPath.Cabinet, CabinetPath.App]),
  },
  {
    title: 'Филиалы',
    path: concatPath([RootPath.Manager, ManagerPath.Cabinet, CabinetPath.Branches]),
  },
  {
    title: 'Профиль',
    path: concatPath([RootPath.Manager]),
    service: 'profile',
    permissions: ['read', 'write'],
  },
];

export const Header = () => {
  const { companyName, name, handleLogout, isLoadingFetch, role, t, addQueryParams } = useHeader();
  usePWAInstall();

  const { hasAccess } = useManagerStore();

  return (
    <header className={s.feature} id="header_main">
      <IconButton className={s.burger} variant="ghost" onClick={() => addQueryParams({ nav: '1' })}>
        <IoMenuSharp />
      </IconButton>

      <ul className={s.controls}>
        <HeaderLang />
        <DesktopNotifications />
        <Tooltip
          offset={12}
          closeOnContentClick
          withArrow
          optionsWrapperClassName={s.options}
          trigger={
            isLoadingFetch ? (
              <Loader size="sm" />
            ) : (
              <div className={s.profile}>
                <Avatar size="sm" name={name} color="#ffd599" />
                {(name || companyName) && (
                  <div className={s.user}>
                    {name && <div className={s.name}>{name}</div>}
                    {role && <div className={s.company}>{t(adminRecord[role])}</div>}
                  </div>
                )}
              </div>
            )
          }
        >
          {links
            .filter(({ roles, service, permissions }) => {
              if (roles) {
                return roles.includes(role!);
              }

              if (service && permissions) {
                return hasAccess(service, permissions);
              }

              return true;
            })
            .map(({ path, title }) => (
              <Link key={path} to={path}>
                <Button size="lg" variant="ghost" className={s.button}>
                  {t(title)}
                </Button>
              </Link>
            ))}
          <Divider />
          <Button size="lg" variant="ghost" onClick={handleLogout} className={s.button}>
            {t('Выйти')}
          </Button>
        </Tooltip>
      </ul>
    </header>
  );
};
